import createAxios from "./axiosHttp";

function getWebhooks() {
  const axios = createAxios();
  let urlPath = `/webhook`;
  return axios.get(urlPath);
}
function getWebhook(id) {
  const axios = createAxios();
  let urlPath = `/webhook/${id}`;
  return axios.get(urlPath);
}
function newWebhook(body) {
  const axios = createAxios();
  let urlPath = `/webhook`;
  return axios.post(urlPath, body);
}

function deleteWebhook(idKey) {
  const axios = createAxios();
  let urlPath = `/webhook/${idKey}`;
  return axios.delete(urlPath);
}
function editWebhook(id, body){
  const axios = createAxios();
  let urlPath = `/webhook/${id}`;
  return axios.put(urlPath, body);

}
export const webhookService = {
  getWebhooks,
  newWebhook,
  editWebhook,
  deleteWebhook,
  getWebhook
};